<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCp_Pais" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCp_Pais.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCp_Pais.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>					
					<br>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCp_Pais',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCp_Pais: {
				IdPais: 0,
				Nombre: '',
				Clave: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCp_Pais.IdPais == 0) {
				await this.$http.post(
					'cpPaises',this.objCp_Pais
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpPaises/'+this.objCp_Pais.IdPais,
					this.objCp_Pais
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpPaises/"+this.objCp_Pais.IdPais
            ).then((res) => {
                this.objCp_Pais = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCp_Pais.Fecha.replace(/-/g,'\/');
                this.objCp_Pais.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCp_Pais = {
				IdPais: 0,
				Nombre: '',
				Clave: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCp_Pais.IdPais = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
